import { render, staticRenderFns } from "./InventoryEdit.vue?vue&type=template&id=c2f62b62"
import script from "./InventoryEdit.vue?vue&type=script&lang=js"
export * from "./InventoryEdit.vue?vue&type=script&lang=js"
import style0 from "./InventoryEdit.vue?vue&type=style&index=0&id=c2f62b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports